import { render, staticRenderFns } from "./ElementOffer.vue?vue&type=template&id=4312fac8&"
import script from "./ElementOffer.vue?vue&type=script&lang=js&"
export * from "./ElementOffer.vue?vue&type=script&lang=js&"
import style0 from "./ElementOffer.vue?vue&type=style&index=0&id=4312fac8&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports